import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './style/index.scss';
import 'react-confirm-alert/src/react-confirm-alert.css';


import App from './App';

import {
    QueryClient,
    QueryClientProvider,
} from 'react-query'
import { ToastContainer } from 'react-toastify';

const root = ReactDOM.createRoot(document.getElementById('root'));

const queryClient = new QueryClient()


root.render(
    <React.StrictMode>
        <Suspense>
            <QueryClientProvider client={queryClient}>

                <ToastContainer />
                <App />

            </QueryClientProvider>
        </Suspense>
    </React.StrictMode>
);

